<template>
  <modal :title="$t('public.calibration_expired')" :visible.sync="isShowDialog" width="700px">
    <template v-if="list.length">
      <div v-for="(item, index) in list" :key="index" class="list-item"
        :class="{'expire-class': item.expireFlag}">
        <el-divider content-position="left">
         <span :class="{'color-red': item.expireFlag}"> {{ $timetransition(item.expireTime, 'Y-M-D') }}</span>
        </el-divider>
        <div class="uk-flex">
          <div v-for="device in item.deviceList" :key="device.id">
            <div v-if="device.deviceCode" class="bg-theme color-white pd-5" style="margin:0 10px 10px 10px;">
              {{ device.deviceCode }}
            </div>
          </div>
        </div>

      </div>
    </template>
    <el-empty v-else :description="$t('public.no_data')"></el-empty>

  </modal>

</template>

<script>
import { getCalibrationExpiredList } from '@/api/modules/sensor.js'

export default {
  name: 'calibrationExpired',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    // 传感器/气体/门磁
    deviceCatalog: {
      type: Number || String,
      default: 0
    }
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    isShowDialog(){
      if(this.isShowDialog){
        this.getListFn()
      }
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  created(){
    this.getListFn()
  },
  methods: {
    // 获取过期提示列表
    getListFn(){
       getCalibrationExpiredList(this.deviceCatalog).then(res => {
          if (res.state.code === 200) {
            let tmpList = []
            // 整理数据，同一日期的设备放在一起
            res.result.forEach(item => {
              let index = tmpList.findIndex(_ => _.expireTime === item.expireTime)
              if(index === -1){
                tmpList.push({
                  type: item.type,
                  scene_id: item.sceneId,
                  expire_time: item.expireTime,
                  deviceList: [
                    {
                      device_id: item.deviceId,
                      device_code: item.deviceCode,
                      device_catalog: item.deviceCatalog
                    }
                  ]
                })
              }else{
                tmpList[index].deviceList.push({
                  device_id: item.deviceId,
                  device_code: item.deviceCode,
                  device_catalog: item.deviceCatalog
                })
              }

            })
            this.list = tmpList
            // 判断过期时间和当前时间
            this.list.forEach(item => {
              if(item.expireTime < Date.now()){
                this.$set(item, 'expireFlag', true)
              }
            })
            // 排序，最新的时间在上面
            this.list.sort((a,b) => {
              return b.expireTime - a.expireTime
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  border: 1px solid #DCDFE6;
  border-top: none;
}
.expire-class {
  &.list-item{
    border: 1px solid red;
     border-top: none;
  }
  ::v-deep.el-divider {
    background-color: red;
  }
}

</style>
